import React, { useRef, useEffect, useState } from 'react';
import { useChat } from '../contexts/ChatContext';
import MessageSidebar from './MessageSidebar';
import ChatMessage from './ChatMessage';
import MessageInput from './MessageInput';
import { socketService } from '../services/websocketService';

const ChatWindow = ({ isMiniMode }) => {
  const { messages, isLoading, recording, speaking } = useChat();
  const endRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Create a new conversation when component mounts
    const checkConnection = () => {
      setIsConnected(socketService.isConnected());
    };
    checkConnection();
    const interval = setInterval(checkConnection, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (endRef.current) {
      endRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isLoading, speaking]);

  return (
    <div className="flex h-full">
      {!isMiniMode && <div className="w-64 hidden md:block"><MessageSidebar /></div>}
      <div className="flex-1 flex flex-col">
        {/* Connection Status Bar */}
        <div className={`px-4 py-2 text-xs flex items-center gap-2 ${isConnected ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
          <div className={`w-2 h-2 rounded-full ${isConnected ? 'bg-green-500' : 'bg-red-500'}`}></div>
          {isConnected ? 'Connected to chat service' : 'Disconnected from chat service'}
        </div>
        <div className="flex-1 overflow-auto p-4">
          {messages?.map((m, i) => (
            <ChatMessage 
              key={i} 
              message={m} 
              isLatestMessage={i === messages.length - 1} 
            />
          ))}
          {recording && (
            <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-lg mb-4">
              <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-red-600 text-sm">Recording...</span>
            </div>
          )}
          {speaking && (
            <div className="flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-lg mb-4">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-green-600 text-sm">Assistant is speaking...</span>
            </div>
          )}
          {isLoading && (
            <div className="flex items-center gap-2 p-3 bg-blue-50 border border-blue-200 rounded-lg mb-4">
              <div className="flex gap-1">
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
              </div>
              <span className="text-blue-600 text-sm">Processing your request...</span>
            </div>
          )}
          <div ref={endRef} />
        </div>
        <MessageInput />
      </div>
    </div>
  );
};

export default ChatWindow; 